import { FunctionComponent, useMemo } from 'react';
import { useLastUpload, useUploadSessions } from '../../services/upload/UploadProvider';
import { OneDriveUploadSession } from '../../services/upload/OneDriveUploadProvider';
import { UploadStatus } from '../../services/upload/utils';

interface Props {}

export const StatusBar: FunctionComponent<Props> = ({}) => {
  const sessions = useUploadSessions<OneDriveUploadSession>();
  const lastUpload = useLastUpload();

  const sessionsToShow = useMemo(() => {
    if (!lastUpload) {
      return [];
    }

    return sessions.filter(session => session.created >= lastUpload)
  }, [sessions, lastUpload]);

  const totalSessions = sessionsToShow.length;
  const uploadingSessions = sessionsToShow.filter(session => session.status === UploadStatus.Complete);
  const numUploadingSessions = uploadingSessions.length;
  const progress = numUploadingSessions / totalSessions;

  return (
    <div className="flex flex-col gap-1 w-full">
      <span className="text-xs">Uploading...</span>
      <div className="border rounded-md h-2 bg-gray-50" style={{ width: '100%' }}>
        <div className="border rounded-md h-full bg-blue-500" style={{ width: `${progress * 100}%` }}></div>
      </div>
    </div>
  );
};
